import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=07f84c8f&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=07f84c8f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f84c8f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07f84c8f')) {
      api.createRecord('07f84c8f', component.options)
    } else {
      api.reload('07f84c8f', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=07f84c8f&scoped=true&", function () {
      api.rerender('07f84c8f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2CptnqCD1BOhY/JS/comp/Voucher.vue"
export default component.exports